export const finalPriceAfterExtractingCommission = (price, percentage) => {
    let finalAmount = price * (1 - percentage / 100);
    return finalAmount;
}